<template>
    <div class="loading-placeholder">
        <div class="ph-item">
            <div class="ph-col-3 justify-content-center">
                <div class="ph-picture"></div>
            </div>

            <div class="ph-col-6 justify-content-center">
                <div class="ph-row">
                    <div class="ph-col-12 empty"></div>

                    <div class="ph-col-4 big"></div>
                    <div class="ph-col-12 empty"></div>

                    <div class="ph-col-8 big"></div>
                    <div class="ph-col-6"></div>

                    <div class="ph-col-12 empty"></div>

                    <div class="ph-col-8"></div>
                    <div class="ph-col-6"></div>

                    <div class="ph-col-12 empty"></div>
                </div>
            </div>

            <div class="ph-col-3 justify-content-center">
                <div class="ph-row">
                    <div class="ph-col-12 empty"></div>

                    <div class="ph-col-4 empty"></div>
                    <div class="ph-col-8 big"></div>

                    <div class="ph-col-6 empty"></div>
                    <div class="ph-col-6 big"></div>
                    <div class="ph-col-8 empty"></div>
                    <div class="ph-col-4"></div>

                    <div class="ph-col-12 empty"></div>

                    <div class="ph-col-2 empty"></div>
                    <div class="ph-col-10 big"></div>
                </div>
            </div>
        </div>

        <div class="ph-item">
            <div class="ph-col-3 justify-content-center">
                <div class="ph-picture"></div>
            </div>

            <div class="ph-col-6 justify-content-center">
                <div class="ph-row">
                    <div class="ph-col-12 empty"></div>

                    <div class="ph-col-4 big"></div>
                    <div class="ph-col-12 empty"></div>

                    <div class="ph-col-8 big"></div>
                    <div class="ph-col-6"></div>

                    <div class="ph-col-12 empty"></div>

                    <div class="ph-col-8"></div>
                    <div class="ph-col-6"></div>

                    <div class="ph-col-12 empty"></div>
                </div>
            </div>

            <div class="ph-col-3 justify-content-center">
                <div class="ph-row">
                    <div class="ph-col-12 empty"></div>

                    <div class="ph-col-4 empty"></div>
                    <div class="ph-col-8 big"></div>

                    <div class="ph-col-6 empty"></div>
                    <div class="ph-col-6 big"></div>
                    <div class="ph-col-8 empty"></div>
                    <div class="ph-col-4"></div>

                    <div class="ph-col-12 empty"></div>

                    <div class="ph-col-2 empty"></div>
                    <div class="ph-col-10 big"></div>
                </div>
            </div>
        </div>

        <div class="ph-item">
            <div class="ph-col-3 justify-content-center">
                <div class="ph-picture"></div>
            </div>

            <div class="ph-col-6 justify-content-center">
                <div class="ph-row">
                    <div class="ph-col-12 empty"></div>

                    <div class="ph-col-4 big"></div>
                    <div class="ph-col-12 empty"></div>

                    <div class="ph-col-8 big"></div>
                    <div class="ph-col-6"></div>

                    <div class="ph-col-12 empty"></div>

                    <div class="ph-col-8"></div>
                    <div class="ph-col-6"></div>

                    <div class="ph-col-12 empty"></div>
                </div>
            </div>

            <div class="ph-col-3 justify-content-center">
                <div class="ph-row">
                    <div class="ph-col-12 empty"></div>

                    <div class="ph-col-4 empty"></div>
                    <div class="ph-col-8 big"></div>

                    <div class="ph-col-6 empty"></div>
                    <div class="ph-col-6 big"></div>
                    <div class="ph-col-8 empty"></div>
                    <div class="ph-col-4"></div>

                    <div class="ph-col-12 empty"></div>

                    <div class="ph-col-2 empty"></div>
                    <div class="ph-col-10 big"></div>
                </div>
            </div>
        </div>

        <div class="ph-item">
            <div class="ph-col-3 justify-content-center">
                <div class="ph-picture"></div>
            </div>

            <div class="ph-col-6 justify-content-center">
                <div class="ph-row">
                    <div class="ph-col-12 empty"></div>

                    <div class="ph-col-4 big"></div>
                    <div class="ph-col-12 empty"></div>

                    <div class="ph-col-8 big"></div>
                    <div class="ph-col-6"></div>

                    <div class="ph-col-12 empty"></div>

                    <div class="ph-col-8"></div>
                    <div class="ph-col-6"></div>

                    <div class="ph-col-12 empty"></div>
                </div>
            </div>

            <div class="ph-col-3 justify-content-center">
                <div class="ph-row">
                    <div class="ph-col-12 empty"></div>

                    <div class="ph-col-4 empty"></div>
                    <div class="ph-col-8 big"></div>

                    <div class="ph-col-6 empty"></div>
                    <div class="ph-col-6 big"></div>
                    <div class="ph-col-8 empty"></div>
                    <div class="ph-col-4"></div>

                    <div class="ph-col-12 empty"></div>

                    <div class="ph-col-2 empty"></div>
                    <div class="ph-col-10 big"></div>
                </div>
            </div>
        </div>

        <div class="ph-item">
            <div class="ph-col-3 justify-content-center">
                <div class="ph-picture"></div>
            </div>

            <div class="ph-col-6 justify-content-center">
                <div class="ph-row">
                    <div class="ph-col-12 empty"></div>

                    <div class="ph-col-4 big"></div>
                    <div class="ph-col-12 empty"></div>

                    <div class="ph-col-8 big"></div>
                    <div class="ph-col-6"></div>

                    <div class="ph-col-12 empty"></div>

                    <div class="ph-col-8"></div>
                    <div class="ph-col-6"></div>

                    <div class="ph-col-12 empty"></div>
                </div>
            </div>

            <div class="ph-col-3 justify-content-center">
                <div class="ph-row">
                    <div class="ph-col-12 empty"></div>

                    <div class="ph-col-4 empty"></div>
                    <div class="ph-col-8 big"></div>

                    <div class="ph-col-6 empty"></div>
                    <div class="ph-col-6 big"></div>
                    <div class="ph-col-8 empty"></div>
                    <div class="ph-col-4"></div>

                    <div class="ph-col-12 empty"></div>

                    <div class="ph-col-2 empty"></div>
                    <div class="ph-col-10 big"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: [],
        data() {
            return {}
        },
        mounted() {},
        computed: {},
        methods: {},
        watch: {}
    }
</script>
